import React from "react";
import style from "./index.module.scss";
import { Link } from "react-router-dom";
import { Dropdown, Icon } from "antd";
import useDeviceType from "../../../../Utils/useDeviceType";

interface HeaderMobileProps {
    menu: React.ReactNode;
}

export default function HeaderMobile({ menu }: HeaderMobileProps) {
    const { isWebview } = useDeviceType();

    return (
        <div className={style.root}>
            <Link to="/" className={style.logo}>
                白果云课堂
            </Link>

            <div className={style.icons}>
                <Link
                    to="/feedback"
                    target={isWebview ? "_self" : "_blank"}
                    className={style.feedback}>
                    <Icon type="edit" />
                </Link>

                {!isWebview && (
                    <a
                        href="https://www.edufe.com.cn/bgyhelp/stu/"
                        target="_blank"
                        className={style.qa}
                    />
                )}

                <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    overlayClassName={style.icons}>
                    <div className={style.profile} />
                </Dropdown>
            </div>
        </div>
    );
}
